<template>
  <Desktop v-if="isDesktop" />
  <Mobile v-else />
</template>

<script>
import Desktop from '../../layouts/Template/Header/Desktop.vue';
import Mobile from '../../layouts/Template/Header/Mobile.vue';

export default {
  name: "Header",
  components: {
    Desktop,
    Mobile
  },
  computed: {
    isDesktop() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return false;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    }
  },
  // mounted() {
  //   for (let menu of this.$refs.submenuButton) {
  //     let element = menu;
  //     // element.$vnode.child.$children[0].event = ""
  //     // console.log(element.$vnode.child);
  //     // console.log(element.$vnode.child.$children[0]);
  //     element.$vnode.child.$children[0].$options.beforeMount.push(function() {
  //       // this.event = ""
  //       // this.$set(this.$options.propsData, 'event', "")
  //       // this.$options.propsData['event'] = ""
  //       // this._props.event = ""
  //       // console.log(this._props);
  //       console.log(this.$data);
  //       // console.log(Object.getOwnPropertySymbols(this._props.event));
  //     })
  //   }
  // }
};
</script>

<style>
#panelNavContainer {
  position: relative;
}
#panel-header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#header-card {
  z-index: 15;
}
#panel-nav-menu-listesi {
  display: flex;
  flex-grow: 1;
  padding: 0 25px;
}
.panel-header-etkilesim {
  display: flex;
}
#panel-kullanici-navbar {
  display: flex;
  align-items: center;
}
.panel-nav-menu {
  display: flex;
  align-items: center;
  list-style-type: none;
}
.panel-nav-menu .v-btn--active {
  background-color: #eee;
}
.panel-nav-menu .v-btn--active .v-btn__content {
  color: #252525;
}
.panel-nav-menu > a {
  padding: 0.5rem;
  cursor: pointer;
  position: relative;
  margin-right: 10px;
}
/* .panel-nav-menu > div::after {
  content:"";
  position: absolute;
  right: -5px;
  top: 50%;
  transform: translate(0, -50%);
  width: 1px;
  height:100%;
  background: linear-gradient(to bottom, transparent, #999, transparent);
} */
.panel-nav-menu > div i {
  line-height: 1em;
}
.panel-nav-items-container.v-list-item {
  padding: 0;
}
.panel-nav-a-items {
  text-decoration: none;
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 0 26px 0 10px;
}
.nav-pin {
  position: relative;
  background-color: #4158d0;
  background-image: linear-gradient(95deg, #4158d0, #9b2a94);
}
/* .nav-pin::after {
  content: "";
  position: absolute;
  width: calc(100% - 1px);
  height: calc(100% - 1px);
  background: #353535;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  transition-duration: 0.28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.panel-nav-menu .v-btn--active.nav-pin::after {
  background: #eee;
}
.nav-pin:hover:after {
  opacity: 0;
} */
/* .nav-pin .v-btn__content {
  position: relative;
  z-index: 5;
} */
/* .nav-pin .v-ripple__container {
  z-index: 6;
} */
.panel-nav-menu .nav-pin.v-btn--active .v-btn__content {
  color: #fff;
}
.nav-is-hover {
  background-color: #eee;
}
.nav-is-hover-item {
  transition: 0.3s;
}
</style>